import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AuthService } from "app/auth/services/auth.service";
import { NgForm } from "@angular/forms";
import { Result } from 'app/core/models/result';
import { AlertMessageComponent } from "app/shared/components/alert-message/alert-message.component";

@Component({
    templateUrl: 'confirm-password.component.html'
})
export class ConfirmPasswordComponent implements OnInit {
    password: string;
    passwordConfirmation: string;
    token: string;
    email: string;
    submitAttempt: boolean;
    errors: string[];
    @ViewChild('passwordConfirmForm', { static: false }) confirmationForm: NgForm;
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;

    constructor(private _activatedRoute: ActivatedRoute, private _authorizationService: AuthService, private _router: Router) {

    }

    ngOnInit(): void {
        //this.token = this._activatedRoute.snapshot.params['token'];
        this.token = this._activatedRoute.snapshot.queryParamMap.get("key");
        this.submitAttempt = false;
        this.errors = [];
        var html = document.getElementsByTagName('html')[0];
        html.className = 'fixed dark';
    }

    attemptPasswordConfirmation(): void {
        this.errors = [];
        this.submitAttempt = true;
        if (this.confirmationForm.valid) {
            if (this.password === this.passwordConfirmation) {
                this._authorizationService.resetPassword(this.email, this.password, this.token).subscribe(
                    sucesss => {
                        this.successReset();
                    },
                    error => {
                        this.errors = (<Result>error).errorList;
                    });
            } else {
                this.errors = ["The password and password confirmation must match."];
            }
        }

    }

    successReset(): void {
        this.alertMessage.showMessage();
    }

    successClicked($event: any): void {
        this._router.navigate(['auth/login']);
    }

    onHide($event: any): void {
        this._router.navigate(['auth/login']);
    }
}
